export const UPDATE_ADVICE_QUERY_PARAM_ID = "updateAdvice";
export const CAMPAIGN_AND_LEAD_QUERY_PARAM_IDS = [
  "leadId",
  "utm_campaign",
  "utm_source",
  "utm_medium",
];
export const CART_ID_PARAM_ID = "cartId";
export const PRODUCT_ID_PARAM_ID = "productId";
export const GRP_PARAM_ID = "grp";
